/**
 * Đường dẫn đặt lịch của tiệm (hàm thuần, K6 / ADR-100).
 *
 * `https://zalo.me/s/<Mini App ID>/?tiem=<mã tiệm>[&cn=<id chi nhánh>]` — định dạng đã kiểm chứng ở
 * docs/zalo/deep-link-mini-app.md. `cn` chỉ để Mini App mở sẵn đúng chi nhánh (QR dán ở cơ sở nào mở cơ sở đó): nó
 * KHÔNG đổi tiệm và không cấp quyền gì — tiệm do `tiem` quyết, và máy chủ vẫn kiểm chi nhánh thuộc tiệm khi đặt.
 */
export function duongDanDatLich(
  miniAppId: string,
  maTiem: string,
  chiNhanhId: string | null = null,
): string {
  const goc = `https://zalo.me/s/${miniAppId}/?tiem=${encodeURIComponent(maTiem)}`
  return chiNhanhId === null ? goc : `${goc}&cn=${encodeURIComponent(chiNhanhId)}`
}

/** Phần tên ngắn không dấu của tên tệp ảnh QR: "Chi nhánh Lê Lợi" → "chi-nhanh-le-loi". Rỗng nếu không còn chữ nào. */
function tenNgan(ten: string): string {
  return ten
    .normalize('NFD')
    .replace(/\p{M}/gu, '')
    .replace(/đ/g, 'd')
    .replace(/Đ/g, 'd')
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '')
    .slice(0, 24)
    .replace(/-+$/g, '')
}

/** Tên tệp ảnh QR: `ma-qr-<mã>.png`, theo chi nhánh thì thêm tên ngắn. */
export function tenFileMaQr(maTiem: string, tenChiNhanh: string | null): string {
  const them = tenChiNhanh === null ? '' : tenNgan(tenChiNhanh)
  return them === '' ? `ma-qr-${maTiem}.png` : `ma-qr-${maTiem}-${them}.png`
}

/**
 * Link + tên tệp ảnh QR từ CÙNG một mã: mã đặt lịch ngẫu nhiên (ADR-056) nếu đã tải được, không thì mã tiệm. Trước đây
 * tên tệp luôn theo mã tiệm còn link theo mã đặt lịch — tệp tải về mang một mã, QR bên trong mang mã khác.
 */
export function linkVaTenFileMaQr(p: {
  miniAppId: string
  maDatLich: string | null
  maTiem: string
  chiNhanh: { id: string; ten: string } | null
}): { link: string; tenFile: string } {
  const ma = p.maDatLich ?? p.maTiem
  return {
    link: duongDanDatLich(p.miniAppId, ma, p.chiNhanh?.id ?? null),
    tenFile: tenFileMaQr(ma, p.chiNhanh?.ten ?? null),
  }
}
